// @flow
import PropTypes from 'prop-types'
import { compose, getContext, lifecycle } from 'recompose'

const ScrollHandler = ({ children }) => children

const GetContext = getContext({
  registerForScroll: PropTypes.func.isRequired,
  unregisterForScroll: PropTypes.func.isRequired
})

export default compose(
  GetContext,
  lifecycle({
    componentDidMount() {
      this.props.registerForScroll(this.props.onScroll)
    },
    componentWillUnmount() {
      this.props.unregisterForScroll(this.props.onScroll)
    }
  })
)(ScrollHandler)



// WEBPACK FOOTER //
// ./src/services/search-results/scroll-handler.js